import styled from "styled-components";
import TextDotDivider from "../components/TextDotDivider";

import dompurify from "dompurify";
import {useEffect, useState} from "react";
import {fetchQuillData} from "../serverAPI";

const Title = styled.p`
  font-size: 25px;
  font-family: signika, sans-serif;
  font-weight: 400;
  color: rgb(0, 148, 255);
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const RatImage = styled.img`
  width: 442px;
`;

const SanitizerInner = styled.div`
  text-align: justify;
  margin-bottom: 50px;

  span {
    line-height: 1.5em;
  }

  & img {
    max-width: 100%;
  }
`;

export default function Facility() {
  const sanitizer = dompurify.sanitize;
  const [facility, setFacility] = useState("");

  useEffect(() => {
    const loadFacilityQuillData = async () => {
      const quillData = await fetchQuillData("facility");
      setFacility(quillData);
    };
    loadFacilityQuillData();
  }, []);
  return (<div>
    <TextDotDivider text="Facility"/>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(facility)}}/>
  </div>);
}
